<template>
  <div class="maxw">
    <h2>Editar Factura</h2>
    <b-form v-on:submit.prevent="updateFactura">
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Num. Factura:">
            <h2>{{ factura.serieIdentifier }} / {{ factura.numFact }}</h2>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Cliente:">
            {{ factura.cliente.nombre }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Fecha Factura:"
            label-for="dp-fechafra"
          >
            <b-form-datepicker
              id="dp-fechafra"
              v-model="factura.fechaFactura"
              required=""
              locale="es"
              placeholder="Seleccionar una fecha"
              today-button
              reset-button
              close-button
              class="mb-2"
            >
            </b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Fecha Vencimiento:"
            label-for="dp-vencimiento"
          >
            <b-form-datepicker
              id="dp-vencimiento"
              v-model="factura.fechaVencimiento"
              locale="es"
              placeholder="Seleccionar una fecha"
              today-button
              reset-button
              close-button
              class="mb-2"
            >
            </b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Base Fra.">
            {{ factura.precioBase }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Iva %">
            {{ factura.iva }}%
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Iva €">
            {{ factura.impuestoIVA }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Total Fra.">
            {{ factura.totalFactura }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Cobrado:"
            label-class="font-weight-bold"
            label-for="input-rep"
          >
            <b-form-checkbox
              v-model="factura.isPagada"
              name="check-button"
              switch
            >
              Pendiente /Cobrada
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Fecha de Cobro:"
            label-for="dp-fechaCobro"
          >
            <b-form-datepicker
              id="dp-fechaCobro"
              v-model="factura.fechaCobro"
              required=""
              locale="es"
              placeholder="Seleccionar una fecha"
              today-button
              reset-button
              close-button
              class="mb-2"
            >
            </b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Banc" label-for="input-nif">
            <b-form-select
              v-model="factura.bancIdentifier"
              :options="bancsData"
              value-field="identifier"
              text-field="nombre"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >-- Seleccione un banco --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Anotación:"
            label-for="textarea-anotacion"
          >
            <b-form-textarea
              id="textarea-anotacion"
              v-model="factura.anotacion"
              placeholder="Anotaciones internas de idealive. No se visualizaran externamente en la fra."
              rows="2"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h3>Lineas Factura</h3>
        </b-col>
      </b-row>
      <table striped hover small>
        <thead>
          <tr>
            <th>Producto</th>
            <th>Cantidad</th>
            <th>Precio</th>
            <th>Dto.</th>
            <th>Importe</th>
            <th style="width: 10%">Accions</th>
          </tr>
        </thead>
        <tbody>
          <LineaFactura
            v-for="(item, i) in this.factura.facturaDetalles"
            :key="item.identifier"
            @deleteLinea="(data) => deleteLineaFactura(i, data)"
            @updateLinea="(data) => updateLineaFactura(i, data)"
            v-bind:linea="item"
            v-bind:productes="productesData"
          />
        </tbody>
      </table>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button class="mr-2" variant="outline-success" type="submit"
            >Gravar</b-button
          >
          <b-button class="mr-2" variant="outline-primary"
            ><router-link :to="{ name: 'Factures' }"
              >Cancel</router-link
            ></b-button
          >
        </b-col>
      </b-row>
      <b-form-input
        :hidden="true"
        type="text"
        v-model="factura.identifier"
      ></b-form-input>
    </b-form>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'
import LineaFactura from '@/components/Factura/LineaFactura.vue'

export default {
  components: {
    LineaFactura
  },
  props: {
    factura: Object
  },
  data () {
    return {
      productesData: [],
      bancsData: [],
      show: true
    }
  },
  created () {
    (async () => {
      await DataAccess.getDataMuliplex2(
        '/api/clientProd/Client/' + this.factura.cliente.identifier,
        'api/bancs'
      )
        .then((responses) => {
          this.productesData = responses[0].data
          this.bancsData = responses[1].data
          this.loading = false
        })
        .catch((error) => {
          this.makeToast(
            'b-toaster-top-full',
            'danger',
            'Error en la càrrega incial.',
            'Errors en la carga.'
          )
          console.log('ERROR CARREGA - PRODUCTES / CLIENT :', error.response)
        })
    })()
  },
  methods: {
    makeToast (toaster, variant, title, message, append = false) {
      this.$bvToast.toast(message, {
        toaster: toaster,
        title: title,
        variant: variant,
        solid: true,
        append: append
      })
    },
    updateFactura () {
      (async () => {
        await DataAccess.putData(
          '/api/facturas',
          this.factura.identifier,
          JSON.stringify(this.factura)
        )
          .then((response) => {
            this.$router.push({ name: 'Factures' })
          })
          .catch((error) => {
            console.log('ERROR: ', error)
          })
      })()
    },
    deleteLineaFactura (indice, item) {
      console.log('DELETE: ', indice + item.identifier)
      // ELIMINA LA LINEA
      // RECALCULA LA FACTURA
      // GRABA LA FACTURA
    },
    updateLineaFactura (value, item) {
      console.log('UPDATE: ', value + item.identifier)
      // ACTUALIZA LA LINEA
      // RECALCULA LA FACTURA
      // GRABA LA FACTURA
    }
  }
}
</script>
